import classNames from "classnames";
import { DotsAccordion, DotsAccordionTab } from "dots-ui/dotsAccordion";
import { AvisDescriptiveText } from "./AvisDescriptiveText";

interface IAvisSectionProps {
  id?: string;
  title?: string;
  textToDisplayKey?: string;
  classNameIn?: string;
  children?: React.ReactNode;
  collapsable?: boolean;
  expanded?: boolean;
  subTitleComponent?: React.ReactNode;
}
export function AvisSection(props: Readonly<IAvisSectionProps>) {
  const {
    id,
    title,
    children,
    classNameIn,
    textToDisplayKey,
    collapsable,
    expanded,
    subTitleComponent,
  } = props;
  const classNameSection = classNames("avis-section", classNameIn);
  const classNameSectionTitle = classNames("avis-section-title");
  const classNameSectionContent = classNames("avis-section-content");

  const renderHeader = () => {
    if (!title) return;

    return <h3 className={classNameSectionTitle}>{title}</h3>;
  };
  const renderTextToDisplay = () => {
    if (!textToDisplayKey) return;

    return <AvisDescriptiveText textKey={textToDisplayKey} />;
  };

  if (!collapsable) {
    return (
      <div id={id} className={classNameSection}>
        {renderHeader()}
        <div className={classNameSectionContent}>
          {subTitleComponent}
          {renderTextToDisplay()}
          {children}
        </div>
      </div>
    );
  }

  const renderTab = () => {
    return [
      <DotsAccordionTab
        key={1}
        className="avis-section-accordion-tab"
        severity="none"
        headerTemplate={renderHeader()}
      >
        <div>
          <div className={classNameSectionContent}>
            {subTitleComponent}
            {renderTextToDisplay()}
            {children}
          </div>
        </div>
      </DotsAccordionTab>,
    ];
  };

  return (
    <div className={classNameSection}>
      <DotsAccordion
        className="avis-section-accordion"
        toggleIconPosition="start"
        spacing="small"
        tabs={renderTab()}
        activeIndex={expanded ? 0 : undefined}
      />
    </div>
  );
}
